import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import { Path } from "../Path";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import logo from "../assets/logo.png";

const premiumFeatures = [
  "Large file uploads & 20GB of storage",
  "Print and Play Support",
  "Enhanced Publisher Directory",
  "Personalised Portfolio",
  "Analytics",
  "Royalty Reminders",
];

export const ConfirmationPage = () => {
  return (
    <Card>
      <CardContent>
        <Box textAlign="center">
          <img src={logo} alt="" style={{ width: 100, height: "auto" }} />

          <Typography variant="h4" component="h1" gutterBottom>
            Welcome to premium!
          </Typography>

          <Typography variant="body1" color="text.secondary" pb={2}>
            You now have access to all premium features. We're excited to help you take your game designs from idea, to
            play test, to pitching and finally to the table.
          </Typography>

          <Box sx={{ textAlign: "left", maxWidth: 400, mx: "auto" }}>
            <List>
              {premiumFeatures.map((feature, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <CheckCircleOutline color="success" />
                  </ListItemIcon>
                  <ListItemText primary={feature} />
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button variant="contained" size="large" component={Link} to={Path.Home}>
          Go to Dashboard
        </Button>
      </CardActions>
    </Card>
  );
};
